module.exports = __webpack_public_path__ + "img/mac_black.d7208488.svg";